"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxCheckboxGroup;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var useStyles = (0, _makeStyles.default)({
  list: {
    paddingTop: 0
  },
  removePaddingHorizontal: {
    paddingLeft: 0,
    paddingRight: 0
  },
  removePaddingTop: {
    paddingTop: 0
  }
});
function ReduxCheckboxGroup(_ref) {
  var _meta$data;
  var id = _ref.id,
    input = _ref.input,
    meta = _ref.meta,
    options = _ref.options;
  var classes = useStyles();
  var error = meta.error || !meta.modifiedSinceLastSubmit && (meta == null ? void 0 : (_meta$data = meta.data) == null ? void 0 : _meta$data.submitError);
  return /*#__PURE__*/_react.default.createElement(_material.List, {
    className: classes.list,
    id: id,
    name: input.name
  }, options.map(function (item, i) {
    var _input$value;
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      key: item.id,
      className: (0, _classnames.default)(classes.removePaddingHorizontal, i === 0 && classes.removePaddingTop),
      id: "".concat(id).concat(i),
      onClick: function onClick() {
        return input.value.includes(item.id) ? input.onChange(input.value.filter(function (val) {
          return val !== item.id;
        })) : input.onChange([].concat((0, _toConsumableArray2.default)(input.value), [item.id]));
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: !!((_input$value = input.value) != null && _input$value.includes(item.id)),
      color: "primary",
      id: "".concat(id).concat(i, "Checkbox"),
      value: item.id.toString()
    }), /*#__PURE__*/_react.default.createElement(_material.ListItemText, {
      className: classes.removePaddingHorizontal,
      id: "".concat(id).concat(i, "Text"),
      primary: item.name,
      secondary: item.description
    }));
  }), meta.touched && error && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: "error",
    id: "".concat(id, "Error"),
    variant: "body2"
  }, error));
}